import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private authService: MsalService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const account: AccountInfo | null = this.authService.instance.getActiveAccount();

    if (account) {
      const idTokenClaims = account.idTokenClaims as any;

      // Check for roles in the token
      const roles = idTokenClaims['roles'] || [];
      const requiredRoles = route.data['roles'] as Array<string>;

      if (requiredRoles && requiredRoles.some(role => roles.includes(role))) {
        return true;
      }
    }

    // Show an alert if roles are not matched
    window.alert('You do not have permission to access this page.');
    return false;
  }
}